import { getApiClient } from "@src/api";
import { graphql } from "@src/gql/gql";

const createCheckoutMutation = graphql(/* GraphQL */ `
	mutation CreateCheckout($priceId: String!, $discountCode: String, $returnUrl:String) {
		plans {
			checkout(priceId: $priceId, discountCode: $discountCode, returnUrl: $returnUrl) {
				secret
			}
		}
	}
`);

export type CreateCheckoutParams = {
	priceId: string;
	discountCode?: string;
	returnUrl?: string;
};

/**
 * Mutation function for creating a Stripe checkout session.
 */
export const createCheckoutMutationFn = async (
	params: CreateCheckoutParams,
) => {
	const client = getApiClient();
	const result = await client.mutate({
		mutation: createCheckoutMutation,
		variables: {
			priceId: params.priceId,
			discountCode: params.discountCode ?? null,
			returnUrl: params.returnUrl ?? null,
		},
	});

	return result.data?.plans.checkout;
};
